// import React, { useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import { getFirestore, collection, query, orderBy, getDocs, limit } from 'firebase/firestore';
// import ChartCard from '../components/ChartCard';
// import { getTopPerformingDays } from '../firebase';
// import '../styles/TransactionsPage.css';

// const TransactionsPage = () => {
//   const { t, i18n } = useTranslation();
//   const isRTL = i18n.dir() === 'rtl';
  
//   const [transactions, setTransactions] = useState([]);
//   const [filteredTransactions, setFilteredTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [filters, setFilters] = useState({
//     dateRange: 'all',
//     minAmount: '',
//     maxAmount: '',
//     customerSearch: '',
//     employeeName: '', // New filter for employee name
//     sortBy: 'date-desc',
//     transactionStatus: 'all'
//   });
//   const [stats, setStats] = useState({
//     totalAmount: 0,
//     totalPoints: 0,
//     averageAmount: 0,
//     transactionCount: 0
//   });
//   const [topDays, setTopDays] = useState([]);
//   const [expandedTransaction, setExpandedTransaction] = useState(null);
//   const [uniqueEmployees, setUniqueEmployees] = useState([]); // Track unique employee names
  
//   // Custom date ranges
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const transactionsPerPage = 10;

//   // Calculate stats from transaction data
//   const updateStats = (transactionsData) => {
//     if (!transactionsData || transactionsData.length === 0) {
//       setStats({
//         totalAmount: 0,
//         totalPoints: 0,
//         averageAmount: 0,
//         transactionCount: 0
//       });
//       return;
//     }

//     try {
//       // Only include active transactions in stats calculations
//       const activeTransactions = transactionsData.filter(t => !t.isDeleted);
      
//       const total = activeTransactions.reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
//       const totalPts = activeTransactions.reduce((sum, t) => sum + (Number(t.points) || 0), 0);
      
//       setStats({
//         totalAmount: total,
//         totalPoints: totalPts,
//         averageAmount: activeTransactions.length > 0 ? Math.round((total / activeTransactions.length) * 100) / 100 : 0,
//         transactionCount: activeTransactions.length
//       });
//     } catch (err) {
//       console.error('Error calculating stats:', err);
//     }
//   };

//   // Extract unique employee names from transactions
//   const extractUniqueEmployees = (transactionsData) => {
//     if (!transactionsData || transactionsData.length === 0) {
//       return [];
//     }

//     try {
//       const employeesSet = new Set();
      
//       transactionsData.forEach(transaction => {
//         if (transaction.employeeName && transaction.employeeName.trim() !== '') {
//           employeesSet.add(transaction.employeeName);
//         }
//       });
      
//       return Array.from(employeesSet).sort();
//     } catch (err) {
//       console.error('Error extracting employee names:', err);
//       return [];
//     }
//   };

//   // Direct Firestore access - bypass getAllTransactions
//   const fetchTransactionsDirectly = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       // Get Firestore instance
//       const db = getFirestore();
      
//       // Access transactions collection directly
//       const transactionsRef = collection(db, "transactions");
//       const q = query(transactionsRef, orderBy("timestamp", "desc"), limit(500)); // Increased limit for better data
      
//       console.log("Executing direct Firestore query...");
//       const querySnapshot = await getDocs(q);
      
//       console.log(`Query returned ${querySnapshot.size} documents`);
      
//       // Clear error if query was successful but empty
//       if (querySnapshot.empty) {
//         console.warn("The transactions collection appears to be empty");
//         setError(t('transactions.errors.noTransactions'));
//         setTransactions([]);
//         setFilteredTransactions([]);
//         updateStats([]);
//         return;
//       }
      
//       // Process the results
//       const fetchedTransactions = [];
//       querySnapshot.forEach((doc) => {
//         const data = doc.data();
//         fetchedTransactions.push({
//           id: doc.id,
//           ...data,
//           // Ensure amount is a number
//           amount: Number(data.amount) || 0,
//           // Ensure points is a number
//           points: Number(data.points) || 0
//         });
//       });
      
//       console.log(`Processed ${fetchedTransactions.length} transactions`);
      
//       if (fetchedTransactions.length > 0) {
//         setTransactions(fetchedTransactions);
//         setFilteredTransactions(fetchedTransactions);
//         updateStats(fetchedTransactions);
        
//         // Extract unique employee names
//         const employees = extractUniqueEmployees(fetchedTransactions);
//         setUniqueEmployees(employees);
//       } else {
//         setError(t('transactions.errors.noValidTransactions'));
//         setTransactions([]);
//         setFilteredTransactions([]);
//         updateStats([]);
//       }
//     } catch (err) {
//       console.error("Error in direct Firestore access:", err);
//       setError(t('transactions.errors.fetchingFailed', { message: err.message }));
//       setTransactions([]);
//       setFilteredTransactions([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch initial data
//   useEffect(() => {
//     console.log("TransactionsPage component mounted");
    
//     const fetchData = async () => {
//       await fetchTransactionsDirectly();
      
//       try {
//         // Fetch top days
//         const topDaysData = await getTopPerformingDays();
//         const displayTopDays = isRTL && topDaysData.length > 0 
//           ? [...topDaysData].reverse() 
//           : topDaysData;
//         setTopDays(displayTopDays || []);
//       } catch (err) {
//         console.error("Error fetching top days:", err);
//       }
//     };

//     fetchData();
//   }, [t, isRTL]);

//   const applyFilters = () => {
//     let filtered = [...transactions];
    
//     // Apply transaction status filter
//     if (filters.transactionStatus !== 'all') {
//       if (filters.transactionStatus === 'active') {
//         filtered = filtered.filter(t => !t.isDeleted);
//       } else if (filters.transactionStatus === 'deleted') {
//         filtered = filtered.filter(t => t.isDeleted);
//       }
//     }
    
//     // Apply employee name filter
//     if (filters.employeeName) {
//       filtered = filtered.filter(t => 
//         t.employeeName === filters.employeeName
//       );
//     }
    
//     // Apply date range filter
//     if (filters.dateRange !== 'all' || (startDate && endDate)) {
//       const now = new Date();
//       let startDateFilter;

//       if (startDate && endDate && filters.dateRange === 'custom') {
//         startDateFilter = new Date(startDate);
//         const endDateFilter = new Date(endDate);
//         endDateFilter.setHours(23, 59, 59, 999); // End of the day

//         filtered = filtered.filter(t => {
//           const txDate = t.timestamp?.toDate ? t.timestamp.toDate() : new Date();
//           return txDate >= startDateFilter && txDate <= endDateFilter;
//         });
//       } else {
//         // Predefined ranges
//         switch (filters.dateRange) {
//           case 'today':
//             startDateFilter = new Date(now.setHours(0, 0, 0, 0));
//             break;
//           case 'yesterday':
//             startDateFilter = new Date(now.setDate(now.getDate() - 1));
//             startDateFilter.setHours(0, 0, 0, 0);
//             break;
//           case 'week':
//             startDateFilter = new Date(now.setDate(now.getDate() - 7));
//             break;
//           case 'month':
//             startDateFilter = new Date(now.setMonth(now.getMonth() - 1));
//             break;
//           default:
//             startDateFilter = null;
//         }

//         if (startDateFilter) {
//           filtered = filtered.filter(t => {
//             const txDate = t.timestamp?.toDate ? t.timestamp.toDate() : new Date();
//             return txDate >= startDateFilter;
//           });
//         }
//       }
//     }

//     // Apply amount filters
//     if (filters.minAmount) {
//       filtered = filtered.filter(t => t.amount >= parseFloat(filters.minAmount));
//     }
//     if (filters.maxAmount) {
//       filtered = filtered.filter(t => t.amount <= parseFloat(filters.maxAmount));
//     }

//     // Apply customer search
//     if (filters.customerSearch) {
//       const searchLower = filters.customerSearch.toLowerCase();
//       filtered = filtered.filter(t => 
//         t.customerName?.toLowerCase().includes(searchLower) || 
//         t.customerId?.toLowerCase().includes(searchLower)
//       );
//     }

//     // Apply sorting
//     switch (filters.sortBy) {
//       case 'date-asc':
//         filtered.sort((a, b) => {
//           return (a.timestamp?.toDate?.() || 0) - (b.timestamp?.toDate?.() || 0);
//         });
//         break;
//       case 'date-desc':
//         filtered.sort((a, b) => {
//           return (b.timestamp?.toDate?.() || 0) - (a.timestamp?.toDate?.() || 0);
//         });
//         break;
//       case 'amount-asc':
//         filtered.sort((a, b) => a.amount - b.amount);
//         break;
//       case 'amount-desc':
//         filtered.sort((a, b) => b.amount - a.amount);
//         break;
//       case 'points-asc':
//         filtered.sort((a, b) => (a.points || 0) - (b.points || 0));
//         break;
//       case 'points-desc':
//         filtered.sort((a, b) => (b.points || 0) - (a.points || 0));
//         break;
//       default:
//         // Default is date descending
//         filtered.sort((a, b) => {
//           return (b.timestamp?.toDate?.() || 0) - (a.timestamp?.toDate?.() || 0);
//         });
//     }

//     // Update filtered transactions and recalculate stats based on filtered data
//     setFilteredTransactions(filtered);
//     updateStats(filtered);
//     setCurrentPage(1); // Reset to first page when filters change
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       dateRange: 'all',
//       minAmount: '',
//       maxAmount: '',
//       customerSearch: '',
//       employeeName: '', // Reset employee filter
//       sortBy: 'date-desc',
//       transactionStatus: 'all'
//     });
//     setStartDate('');
//     setEndDate('');
//     setFilteredTransactions(transactions);
//     updateStats(transactions);
//     setCurrentPage(1);
//   };

//   const toggleExpandTransaction = (id) => {
//     if (expandedTransaction === id) {
//       setExpandedTransaction(null);
//     } else {
//       setExpandedTransaction(id);
//     }
//   };

//   // Get current transactions for pagination
//   const indexOfLastTransaction = currentPage * transactionsPerPage;
//   const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
//   const currentTransactions = filteredTransactions.slice(
//     indexOfFirstTransaction, 
//     indexOfLastTransaction
//   );

//   // Change page
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const pageNumbers = [];
//   for (let i = 1; i <= Math.ceil(filteredTransactions.length / transactionsPerPage); i++) {
//     pageNumbers.push(i);
//   }

//   // Format currency based on locale
//   const formatCurrency = (amount) => {
//     if (isRTL) {
//       return `${amount.toFixed(2)} ₪`;
//     }
//     return `₪${amount.toFixed(2)}`;
//   };

//   return (
//     <div className={`transactions-page ${isRTL ? 'rtl' : ''}`}>
//       <div className="page-title">
//         <h2>{t('transactions.title')}</h2>
//         <p className="subtitle">{t('transactions.subtitle')}</p>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <div className="error-message">
//           <p>{error}</p>
//           <p>{t('transactions.errors.checkDatabase')}</p>
//         </div>
//       )}

//       {/* Stats Overview - Now includes totalAmount */}
//       <div className="stats-grid">
//         <div className="stat-card blue">
//           <div className="stat-icon">💳</div>
//           <div className="stat-info">
//             <h3 className="stat-title">{t('transactions.stats.totalTransactions')}</h3>
//             <div className="stat-value">{stats.transactionCount.toLocaleString(i18n.language)}</div>
//           </div>
//         </div>
//         <div className="stat-card green">
//           <div className="stat-icon">⭐</div>
//           <div className="stat-info">
//             <h3 className="stat-title">{t('transactions.stats.totalPoints')}</h3>
//             <div className="stat-value">{stats.totalPoints.toLocaleString(i18n.language)}</div>
//           </div>
//         </div>
//         {/* New Total Amount stat card */}
//         <div className="stat-card purple">
//           <div className="stat-icon">💰</div>
//           <div className="stat-info">
//             <h3 className="stat-title">{'إجمالي المبلغ'}</h3>
//             <div className="stat-value">{formatCurrency(stats.totalAmount)}</div>
//           </div>
//         </div>
//       </div>

//       {/* Filter Section */}
//       <div className="filter-section">
//         <div className="filter-card">
//           <h3 className="filter-title">{t('transactions.filter.title')}</h3>
//           <div className="filter-grid">
//             <div className="filter-group">
//               <label className="filter-label">{t('transactions.filter.dateRange.label')}</label>
//               <select 
//                 name="dateRange" 
//                 value={filters.dateRange} 
//                 onChange={handleFilterChange}
//                 className="filter-select"
//               >
//                 <option value="all">{t('transactions.filter.dateRange.options.all')}</option>
//                 <option value="today">{t('transactions.filter.dateRange.options.today')}</option>
//                 <option value="yesterday">{t('transactions.filter.dateRange.options.yesterday')}</option>
//                 <option value="week">{t('transactions.filter.dateRange.options.week')}</option>
//                 <option value="month">{t('transactions.filter.dateRange.options.month')}</option>
//                 <option value="custom">{t('transactions.filter.dateRange.options.custom')}</option>
//               </select>
//             </div>

//             {filters.dateRange === 'custom' && (
//               <div className="filter-group date-range">
//                 <div className="filter-date">
//                   <label className="filter-label">{t('transactions.filter.dateRange.start')}</label>
//                   <input 
//                     type="date" 
//                     value={startDate} 
//                     onChange={(e) => setStartDate(e.target.value)}
//                     className="filter-input"
//                   />
//                 </div>
//                 <div className="filter-date">
//                   <label className="filter-label">{t('transactions.filter.dateRange.end')}</label>
//                   <input 
//                     type="date" 
//                     value={endDate} 
//                     onChange={(e) => setEndDate(e.target.value)}
//                     className="filter-input"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Employee Name filter dropdown */}
//             <div className="filter-group">
//               <label className="filter-label">{'الموظف'}</label>
//               <select
//                 name="employeeName"
//                 value={filters.employeeName}
//                 onChange={handleFilterChange}
//                 className="filter-select"
//               >
//                 <option value="">{'جميع الموظفين'}</option>
//                 {uniqueEmployees.map((employee, index) => (
//                   <option key={index} value={employee}>{employee}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Transaction status filter */}
//             <div className="filter-group">
//               <label className="filter-label">{t('transactions.filter.status.label') || 'الحالة'}</label>
//               <select 
//                 name="transactionStatus" 
//                 value={filters.transactionStatus} 
//                 onChange={handleFilterChange}
//                 className="filter-select"
//               >
//                 <option value="all">{t('transactions.filter.status.options.all') || 'جميع المعاملات'}</option>
//                 <option value="active">{t('transactions.filter.status.options.active') || 'المعاملات النشطة'}</option>
//                 <option value="deleted">{t('transactions.filter.status.options.deleted') || 'المعاملات الملغية'}</option>
//               </select>
//             </div>

//             {/* <div className="filter-group">
//               <label className="filter-label">{t('transactions.filter.amount.min')}</label>
//               <input 
//                 type="number" 
//                 name="minAmount" 
//                 value={filters.minAmount} 
//                 onChange={handleFilterChange}
//                 className="filter-input"
//                 placeholder={t('transactions.filter.amount.placeholder')}
//               />
//             </div>

//             <div className="filter-group">
//               <label className="filter-label">{t('transactions.filter.amount.max')}</label>
//               <input 
//                 type="number" 
//                 name="maxAmount" 
//                 value={filters.maxAmount} 
//                 onChange={handleFilterChange}
//                 className="filter-input"
//                 placeholder={t('transactions.filter.amount.placeholder')}
//               />
//             </div> */}

//             <div className="filter-group">
//               <label className="filter-label">{t('transactions.filter.customer.label')}</label>
//               <input 
//                 type="text" 
//                 name="customerSearch" 
//                 value={filters.customerSearch} 
//                 onChange={handleFilterChange}
//                 className="filter-input"
//                 placeholder={t('transactions.filter.customer.placeholder')}
//               />
//             </div>

//             <div className="filter-group">
//               <label className="filter-label">{t('transactions.filter.sort.label')}</label>
//               <select 
//                 name="sortBy" 
//                 value={filters.sortBy} 
//                 onChange={handleFilterChange}
//                 className="filter-select"
//               >
//                 <option value="date-desc">{t('transactions.filter.sort.options.dateDesc')}</option>
//                 <option value="date-asc">{t('transactions.filter.sort.options.dateAsc')}</option>
//                 <option value="amount-desc">{t('transactions.filter.sort.options.amountDesc')}</option>
//                 <option value="amount-asc">{t('transactions.filter.sort.options.amountAsc')}</option>
//                 <option value="points-desc">{t('transactions.filter.sort.options.pointsDesc')}</option>
//                 <option value="points-asc">{t('transactions.filter.sort.options.pointsAsc')}</option>
//               </select>
//             </div>
//           </div>

//           <div className="filter-actions">
//             <button onClick={applyFilters} className="primary-button">{t('transactions.filter.buttons.apply')}</button>
//             <button onClick={resetFilters} className="secondary-button">{t('transactions.filter.buttons.reset')}</button>
//           </div>
//         </div>
//       </div>

//       {/* Transactions Analytics */}
//       <div className="analytics-section">
//         <ChartCard title={t('transactions.analytics.topDays')}>
//           {topDays.length > 0 && topDays.some(day => day.totalAmount > 0) ? (
//             <div className="chart-placeholder">
//               <div className={`chart-bars ${isRTL ? 'chart-bars-rtl' : ''}`}>
//                 {topDays.map((day, index) => {
//                   // Calculate max amount safely
//                   const maxAmount = Math.max(...topDays.map(d => d.totalAmount || 0));
//                   // Calculate percentage height (avoid division by zero)
//                   const heightPercentage = maxAmount > 0 
//                     ? (day.totalAmount / maxAmount) * 100 
//                     : 0;
                    
//                   return (
//                     <div className="chart-bar-container" key={index}>
//                       <div 
//                         className="chart-bar" 
//                         style={{ 
//                           height: `${heightPercentage}%`,
//                           // Make bars at least 5px tall so they're visible even with tiny values
//                           minHeight: heightPercentage > 0 ? '5px' : '0'
//                         }}
//                       ></div>
//                       <div className="chart-label">{t(`transactions.days.${day.day.toLowerCase()}`)}</div>
//                       <div className="chart-value">
//                         {isRTL
//                           ? `${day.totalAmount.toFixed(2)} ₪`
//                           : `₪${day.totalAmount.toFixed(2)}`}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           ) : (
//             <div className="empty-chart-state">
//               <p>{t('transactions.analytics.noData')}</p>
//               <p>{t('transactions.analytics.addTransactions')}</p>
//             </div>
//           )}
//         </ChartCard>
//       </div>

//       {/* Transactions Table */}
//       <div className="transactions-table-section">
//         <div className="transactions-header">
//           <h3 className="section-title">{t('transactions.tableHeader.title')}</h3>
//           <div className="transactions-count">
//             {t('transactions.tableHeader.count', { count: filteredTransactions.length })}
//           </div>
//         </div>
        
//         {loading ? (
//           <div className="loading-container">{t('common.loading')}</div>
//         ) : currentTransactions.length > 0 ? (
//           <div className="enhanced-table">
//             <div className="enhanced-table-header">
//               <div className="header-cell">{t('transactions.table.date')}</div>
//               <div className="header-cell">{t('transactions.table.customer')}</div>
//               <div className="header-cell">{t('transactions.table.amount')}</div>
//               <div className="header-cell">{t('transactions.table.points')}</div>
//               <div className="header-cell">{t('transactions.table.status')}</div>
//               <div className="header-cell">{t('transactions.table.details')}</div>
//             </div>
            
//             <div className="enhanced-table-body">
//               {currentTransactions.map(transaction => (
//                 <React.Fragment key={transaction.id}>
//                   <div className={`enhanced-table-row ${
//                     expandedTransaction === transaction.id ? 'expanded' : ''
//                   } ${transaction.isDeleted ? 'deleted-transaction' : ''}`}>
//                     <div className="table-cell date-cell">
//                       {transaction.timestamp?.toDate ? 
//                         transaction.timestamp.toDate().toLocaleString(i18n.language) : 
//                         t('common.recent')}
//                     </div>
//                     <div className="table-cell">
//                       <div className="customer-name">{transaction.customerName || t('transactions.table.unknown')}</div>
//                       <div className="customer-phone">{transaction.customerId}</div>
//                     </div>
//                     <div className="table-cell amount-cell">
//                       {transaction.isDeleted ? (
//                         <span className="deleted-text"><s>{formatCurrency(transaction.amount)}</s></span>
//                       ) : (
//                         formatCurrency(transaction.amount)
//                       )}
//                     </div>
//                     <div className="table-cell points-cell">
//                       {transaction.isDeleted ? (
//                         <span className="deleted-text"><s>{transaction.points}</s></span>
//                       ) : (
//                         transaction.points
//                       )}
//                     </div>
//                     <div className="table-cell">
//                       {transaction.isDeleted ? (
//                         <span className="status-badge deleted">{t('transactions.status.deleted') || 'ملغية'}</span>
//                       ) : transaction.isFirstPurchase ? (
//                         <span className="status-badge new">{t('transactions.status.new')}</span>
//                       ) : transaction.points < 0 ? (
//                         <span className="status-badge redeem">{t('transactions.status.redeem')}</span>
//                       ) : transaction.points >= 100 ? (
//                         <span className="status-badge reward">{t('transactions.status.highValue')}</span>
//                       ) : (
//                         <span className="status-badge standard">{t('transactions.status.standard') || 'عادية'}</span>
//                       )}
//                     </div>
//                     <div className="table-cell actions-cell">
//                       <button 
//                         onClick={() => toggleExpandTransaction(transaction.id)} 
//                         className="icon-button"
//                         aria-label={expandedTransaction === transaction.id ? 
//                           t('transactions.actions.collapse') : 
//                           t('transactions.actions.expand')}
//                       >
//                         {expandedTransaction === transaction.id ? '↑' : '↓'}
//                       </button>
//                     </div>
//                   </div>
                  
//                   {expandedTransaction === transaction.id && (
//                     <div className="expanded-content">
//                       <div className="expanded-grid">
//                         <div>
//                           <div className="expanded-label">{t('transactions.expanded.id')}</div>
//                           <div className="expanded-value">{transaction.id}</div>
//                         </div>
//                         <div>
//                           <div className="expanded-label">{t('transactions.expanded.customer')}</div>
//                           <div className="expanded-value">{transaction.customerName || t('transactions.table.unknown')}</div>
//                         </div>
//                         <div>
//                           <div className="expanded-label">{t('transactions.expanded.phone')}</div>
//                           <div className="expanded-value">{transaction.customerId || t('transactions.table.noID')}</div>
//                         </div>
//                         <div>
//                           <div className="expanded-label">{t('transactions.expanded.dateTime')}</div>
//                           <div className="expanded-value">
//                             {transaction.timestamp?.toDate ? 
//                               transaction.timestamp.toDate().toLocaleString(i18n.language) : 
//                               t('common.recent')}
//                           </div>
//                         </div>
//                         <div>
//                           <div className="expanded-label">{t('transactions.expanded.amount')}</div>
//                           <div className="expanded-value">{formatCurrency(transaction.amount)}</div>
//                         </div>
//                         <div>
//                           <div className="expanded-label">{t('transactions.expanded.pointsEarned')}</div>
//                           <div className="expanded-value">{transaction.points}</div>
//                         </div>
                        
//                         {transaction.employeeName && (
//                           <div>
//                             <div className="expanded-label">{t('transactions.expanded.employee') || 'الموظف'}</div>
//                             <div className="expanded-value">{transaction.employeeName}</div>
//                           </div>
//                         )}
                        
//                         <div>
//                           <div className="expanded-label">{t('transactions.expanded.type')}</div>
//                           <div className="expanded-value">
//                             {transaction.isRedemption ? 
//                               t('transactions.type.redemption') || 'استبدال' : 
//                               transaction.isFirstPurchase ? 
//                                 t('transactions.type.first') : 
//                                 t('transactions.type.regular')}
//                           </div>
//                         </div>
                        
//                         {/* Add deletion information if applicable */}
//                         {transaction.isDeleted && (
//                           <>
//                             <div>
//                               <div className="expanded-label">{t('transactions.expanded.deletedAt') || 'تاريخ الإلغاء'}</div>
//                               <div className="expanded-value highlight-deleted">
//                                 {transaction.deletedAt?.toDate ? 
//                                   transaction.deletedAt.toDate().toLocaleString(i18n.language) : 
//                                   t('common.unknown')}
//                               </div>
//                             </div>
//                             <div>
//                               <div className="expanded-label">{t('transactions.expanded.deletedBy') || 'تم الإلغاء بواسطة'}</div>
//                               <div className="expanded-value highlight-deleted">{transaction.deletedBy || t('common.unknown')}</div>
//                             </div>
//                           </>
//                         )}
//                       </div>
//                     </div>
//                   )}
//                 </React.Fragment>
//               ))}
//             </div>
//           </div>
//         ) : (
//           <div className="empty-state">{t('transactions.empty')}</div>
//         )}
        
//         {/* Pagination */}
//         {filteredTransactions.length > transactionsPerPage && (
//           <div className="pagination">
//             <button 
//               onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//               className="page-button"
//             >
//               {isRTL ? "السابق" : "التالي"}
//             </button>
            
//             {pageNumbers.map(number => (
//               <button
//                 key={number}
//                 onClick={() => paginate(number)}
//                 className={`page-number ${currentPage === number ? 'active' : ''}`}
//               >
//                 {number}
//               </button>
//             ))}
            
//             <button 
//                 onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredTransactions.length / transactionsPerPage)))}
//                 disabled={currentPage === Math.ceil(filteredTransactions.length / transactionsPerPage)}
//                 className="page-button"
//               >
//                 {isRTL ? "التالي" : "السابق"}
//               </button>
//             </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default TransactionsPage;

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getFirestore, collection, query, orderBy, getDocs, limit } from 'firebase/firestore';
import ChartCard from '../components/ChartCard';
import { getTopPerformingDays } from '../firebase';
import '../styles/TransactionsPage.css';

const TransactionsPage = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';
  
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    dateRange: 'all',
    minAmount: '',
    maxAmount: '',
    customerSearch: '',
    employeeName: '', // Filter for employee name
    category: '', // New filter for category
    sortBy: 'date-desc',
    transactionStatus: 'all'
  });
  const [stats, setStats] = useState({
    totalAmount: 0,
    totalPoints: 0,
    averageAmount: 0,
    transactionCount: 0
  });
  const [topDays, setTopDays] = useState([]);
  const [expandedTransaction, setExpandedTransaction] = useState(null);
  const [uniqueEmployees, setUniqueEmployees] = useState([]); // Track unique employee names
  const [uniqueCategories, setUniqueCategories] = useState([]); // Track unique categories
  
  // Custom date ranges
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const transactionsPerPage = 10;

  // Calculate stats from transaction data
  const updateStats = (transactionsData) => {
    if (!transactionsData || transactionsData.length === 0) {
      setStats({
        totalAmount: 0,
        totalPoints: 0,
        averageAmount: 0,
        transactionCount: 0
      });
      return;
    }

    try {
      // Only include active transactions in stats calculations
      const activeTransactions = transactionsData.filter(t => !t.isDeleted);
      
      const total = activeTransactions.reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
      const totalPts = activeTransactions.reduce((sum, t) => sum + (Number(t.points) || 0), 0);
      
      setStats({
        totalAmount: total,
        totalPoints: totalPts,
        averageAmount: activeTransactions.length > 0 ? Math.round((total / activeTransactions.length) * 100) / 100 : 0,
        transactionCount: activeTransactions.length
      });
    } catch (err) {
      console.error('Error calculating stats:', err);
    }
  };

  // Extract unique employee names from transactions
  const extractUniqueEmployees = (transactionsData) => {
    if (!transactionsData || transactionsData.length === 0) {
      return [];
    }

    try {
      const employeesSet = new Set();
      
      transactionsData.forEach(transaction => {
        if (transaction.employeeName && transaction.employeeName.trim() !== '') {
          employeesSet.add(transaction.employeeName);
        }
      });
      
      return Array.from(employeesSet).sort();
    } catch (err) {
      console.error('Error extracting employee names:', err);
      return [];
    }
  };

  // Extract unique categories from transactions
  const extractUniqueCategories = (transactionsData) => {
    if (!transactionsData || transactionsData.length === 0) {
      return [];
    }

    try {
      const categoriesSet = new Set();
      
      transactionsData.forEach(transaction => {
        if (transaction.category && transaction.category.trim() !== '') {
          categoriesSet.add(transaction.category);
        }
      });
      
      return Array.from(categoriesSet).sort();
    } catch (err) {
      console.error('Error extracting categories:', err);
      return [];
    }
  };

  // Direct Firestore access - bypass getAllTransactions
  const fetchTransactionsDirectly = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Get Firestore instance
      const db = getFirestore();
      
      // Access transactions collection directly
      const transactionsRef = collection(db, "transactions");
      const q = query(transactionsRef, orderBy("timestamp", "desc"), limit(500)); // Increased limit for better data
      
      console.log("Executing direct Firestore query...");
      const querySnapshot = await getDocs(q);
      
      console.log(`Query returned ${querySnapshot.size} documents`);
      
      // Clear error if query was successful but empty
      if (querySnapshot.empty) {
        console.warn("The transactions collection appears to be empty");
        setError(t('transactions.errors.noTransactions'));
        setTransactions([]);
        setFilteredTransactions([]);
        updateStats([]);
        return;
      }
      
      // Process the results
      const fetchedTransactions = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        fetchedTransactions.push({
          id: doc.id,
          ...data,
          // Ensure amount is a number
          amount: Number(data.amount) || 0,
          // Ensure points is a number
          points: Number(data.points) || 0
        });
      });
      
      console.log(`Processed ${fetchedTransactions.length} transactions`);
      
      if (fetchedTransactions.length > 0) {
        setTransactions(fetchedTransactions);
        setFilteredTransactions(fetchedTransactions);
        updateStats(fetchedTransactions);
        
        // Extract unique employee names and categories
        const employees = extractUniqueEmployees(fetchedTransactions);
        setUniqueEmployees(employees);
        
        const categories = extractUniqueCategories(fetchedTransactions);
        setUniqueCategories(categories);
      } else {
        setError(t('transactions.errors.noValidTransactions'));
        setTransactions([]);
        setFilteredTransactions([]);
        updateStats([]);
      }
    } catch (err) {
      console.error("Error in direct Firestore access:", err);
      setError(t('transactions.errors.fetchingFailed', { message: err.message }));
      setTransactions([]);
      setFilteredTransactions([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch initial data
  useEffect(() => {
    console.log("TransactionsPage component mounted");
    
    const fetchData = async () => {
      await fetchTransactionsDirectly();
      
      try {
        // Fetch top days
        const topDaysData = await getTopPerformingDays();
        const displayTopDays = isRTL && topDaysData.length > 0 
          ? [...topDaysData].reverse() 
          : topDaysData;
        setTopDays(displayTopDays || []);
      } catch (err) {
        console.error("Error fetching top days:", err);
      }
    };

    fetchData();
  }, [t, isRTL]);

  const applyFilters = () => {
    let filtered = [...transactions];
    
    // Apply transaction status filter
    if (filters.transactionStatus !== 'all') {
      if (filters.transactionStatus === 'active') {
        filtered = filtered.filter(t => !t.isDeleted);
      } else if (filters.transactionStatus === 'deleted') {
        filtered = filtered.filter(t => t.isDeleted);
      }
    }
    
    // Apply employee name filter
    if (filters.employeeName) {
      filtered = filtered.filter(t => 
        t.employeeName === filters.employeeName
      );
    }
    
    // Apply category filter
    if (filters.category) {
      filtered = filtered.filter(t => 
        t.category === filters.category
      );
    }
    
    // Apply date range filter
    if (filters.dateRange !== 'all' || (startDate && endDate)) {
      const now = new Date();
      let startDateFilter;

      if (startDate && endDate && filters.dateRange === 'custom') {
        startDateFilter = new Date(startDate);
        const endDateFilter = new Date(endDate);
        endDateFilter.setHours(23, 59, 59, 999); // End of the day

        filtered = filtered.filter(t => {
          const txDate = t.timestamp?.toDate ? t.timestamp.toDate() : new Date();
          return txDate >= startDateFilter && txDate <= endDateFilter;
        });
      } else {
        // Predefined ranges
        switch (filters.dateRange) {
          case 'today':
            startDateFilter = new Date(now.setHours(0, 0, 0, 0));
            break;
          case 'yesterday':
            startDateFilter = new Date(now.setDate(now.getDate() - 1));
            startDateFilter.setHours(0, 0, 0, 0);
            break;
          case 'week':
            startDateFilter = new Date(now.setDate(now.getDate() - 7));
            break;
          case 'month':
            startDateFilter = new Date(now.setMonth(now.getMonth() - 1));
            break;
          default:
            startDateFilter = null;
        }

        if (startDateFilter) {
          filtered = filtered.filter(t => {
            const txDate = t.timestamp?.toDate ? t.timestamp.toDate() : new Date();
            return txDate >= startDateFilter;
          });
        }
      }
    }

    // Apply amount filters
    if (filters.minAmount) {
      filtered = filtered.filter(t => t.amount >= parseFloat(filters.minAmount));
    }
    if (filters.maxAmount) {
      filtered = filtered.filter(t => t.amount <= parseFloat(filters.maxAmount));
    }

    // Apply customer search
    if (filters.customerSearch) {
      const searchLower = filters.customerSearch.toLowerCase();
      filtered = filtered.filter(t => 
        t.customerName?.toLowerCase().includes(searchLower) || 
        t.customerId?.toLowerCase().includes(searchLower)
      );
    }

    // Apply sorting
    switch (filters.sortBy) {
      case 'date-asc':
        filtered.sort((a, b) => {
          return (a.timestamp?.toDate?.() || 0) - (b.timestamp?.toDate?.() || 0);
        });
        break;
      case 'date-desc':
        filtered.sort((a, b) => {
          return (b.timestamp?.toDate?.() || 0) - (a.timestamp?.toDate?.() || 0);
        });
        break;
      case 'amount-asc':
        filtered.sort((a, b) => a.amount - b.amount);
        break;
      case 'amount-desc':
        filtered.sort((a, b) => b.amount - a.amount);
        break;
      case 'points-asc':
        filtered.sort((a, b) => (a.points || 0) - (b.points || 0));
        break;
      case 'points-desc':
        filtered.sort((a, b) => (b.points || 0) - (a.points || 0));
        break;
      default:
        // Default is date descending
        filtered.sort((a, b) => {
          return (b.timestamp?.toDate?.() || 0) - (a.timestamp?.toDate?.() || 0);
        });
    }

    // Update filtered transactions and recalculate stats based on filtered data
    setFilteredTransactions(filtered);
    updateStats(filtered);
    setCurrentPage(1); // Reset to first page when filters change
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      dateRange: 'all',
      minAmount: '',
      maxAmount: '',
      customerSearch: '',
      employeeName: '', // Reset employee filter
      category: '', // Reset category filter
      sortBy: 'date-desc',
      transactionStatus: 'all'
    });
    setStartDate('');
    setEndDate('');
    setFilteredTransactions(transactions);
    updateStats(transactions);
    setCurrentPage(1);
  };

  const toggleExpandTransaction = (id) => {
    if (expandedTransaction === id) {
      setExpandedTransaction(null);
    } else {
      setExpandedTransaction(id);
    }
  };

  // Get current transactions for pagination
  const indexOfLastTransaction = currentPage * transactionsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
  const currentTransactions = filteredTransactions.slice(
    indexOfFirstTransaction, 
    indexOfLastTransaction
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(filteredTransactions.length / transactionsPerPage);

  // Generate smart page numbers: 1 ... 4 5 [6] 7 8 ... 20
  const getPageNumbers = (current, total) => {
    if (total <= 5) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const pages = new Set([1, total]);
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
      pages.add(i);
    }
    const sorted = [...pages].sort((a, b) => a - b);
    const result = [];
    for (let i = 0; i < sorted.length; i++) {
      if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
        result.push('...');
      }
      result.push(sorted[i]);
    }
    return result;
  };
  const pageNumbers = getPageNumbers(currentPage, totalPages);

  // Format currency based on locale
  const formatCurrency = (amount) => {
    if (isRTL) {
      return `${amount.toFixed(2)} ₪`;
    }
    return `₪${amount.toFixed(2)}`;
  };

  return (
    <div className={`transactions-page ${isRTL ? 'rtl' : ''}`}>
      <div className="page-title">
        <h2>{t('transactions.title')}</h2>
        <p className="subtitle">{t('transactions.subtitle')}</p>
      </div>

      {/* Error Message */}
      {error && (
        <div className="error-message">
          <p>{error}</p>
          <p>{t('transactions.errors.checkDatabase')}</p>
        </div>
      )}

      {/* Stats Overview - Now includes totalAmount */}
      <div className="stats-grid">
        <div className="stat-card blue">
          <div className="stat-icon">💳</div>
          <div className="stat-info">
            <h3 className="stat-title">{t('transactions.stats.totalTransactions')}</h3>
            <div className="stat-value">{stats.transactionCount.toLocaleString(i18n.language)}</div>
          </div>
        </div>
        <div className="stat-card green">
          <div className="stat-icon">⭐</div>
          <div className="stat-info">
            <h3 className="stat-title">{t('transactions.stats.totalPoints')}</h3>
            <div className="stat-value">{stats.totalPoints.toLocaleString(i18n.language)}</div>
          </div>
        </div>
        {/* New Total Amount stat card */}
        <div className="stat-card purple">
          <div className="stat-icon">💰</div>
          <div className="stat-info">
            <h3 className="stat-title">{'إجمالي المبلغ'}</h3>
            <div className="stat-value">{formatCurrency(stats.totalAmount)}</div>
          </div>
        </div>
      </div>

      {/* Filter Section */}
      <div className="filter-section">
        <div className="filter-card">
          <h3 className="filter-title">{t('transactions.filter.title')}</h3>
          <div className="filter-grid">
            <div className="filter-group">
              <label className="filter-label">{t('transactions.filter.dateRange.label')}</label>
              <select 
                name="dateRange" 
                value={filters.dateRange} 
                onChange={handleFilterChange}
                className="filter-select"
              >
                <option value="all">{t('transactions.filter.dateRange.options.all')}</option>
                <option value="today">{t('transactions.filter.dateRange.options.today')}</option>
                <option value="yesterday">{t('transactions.filter.dateRange.options.yesterday')}</option>
                <option value="week">{t('transactions.filter.dateRange.options.week')}</option>
                <option value="month">{t('transactions.filter.dateRange.options.month')}</option>
                <option value="custom">{t('transactions.filter.dateRange.options.custom')}</option>
              </select>
            </div>

            {filters.dateRange === 'custom' && (
              <div className="filter-group date-range">
                <div className="filter-date">
                  <label className="filter-label">{t('transactions.filter.dateRange.start')}</label>
                  <input 
                    type="date" 
                    value={startDate} 
                    onChange={(e) => setStartDate(e.target.value)}
                    className="filter-input"
                  />
                </div>
                <div className="filter-date">
                  <label className="filter-label">{t('transactions.filter.dateRange.end')}</label>
                  <input 
                    type="date" 
                    value={endDate} 
                    onChange={(e) => setEndDate(e.target.value)}
                    className="filter-input"
                  />
                </div>
              </div>
            )}

            {/* Employee Name filter dropdown */}
            <div className="filter-group">
              <label className="filter-label">{'الموظف'}</label>
              <select
                name="employeeName"
                value={filters.employeeName}
                onChange={handleFilterChange}
                className="filter-select"
              >
                <option value="">{'جميع الموظفين'}</option>
                {uniqueEmployees.map((employee, index) => (
                  <option key={index} value={employee}>{employee}</option>
                ))}
              </select>
            </div>

            {/* New Category filter dropdown */}
            <div className="filter-group">
              <label className="filter-label">فئة المشتريات</label>
              <select
                name="category"
                value={filters.category}
                onChange={handleFilterChange}
                className="filter-select"
              >
                <option value="">جميع الفئات</option>
                {uniqueCategories.map((category, index) => (
                  <option key={index} value={category}>{category}</option>
                ))}
              </select>
            </div>

            {/* Transaction status filter */}
            <div className="filter-group">
              <label className="filter-label">{t('transactions.filter.status.label') || 'الحالة'}</label>
              <select 
                name="transactionStatus" 
                value={filters.transactionStatus} 
                onChange={handleFilterChange}
                className="filter-select"
              >
                <option value="all">{t('transactions.filter.status.options.all') || 'جميع المعاملات'}</option>
                <option value="active">{t('transactions.filter.status.options.active') || 'المعاملات النشطة'}</option>
                <option value="deleted">{t('transactions.filter.status.options.deleted') || 'المعاملات الملغية'}</option>
              </select>
            </div>

            {/* <div className="filter-group">
              <label className="filter-label">{t('transactions.filter.amount.min')}</label>
              <input 
                type="number" 
                name="minAmount" 
                value={filters.minAmount} 
                onChange={handleFilterChange}
                className="filter-input"
                placeholder={t('transactions.filter.amount.placeholder')}
              />
            </div>

            <div className="filter-group">
              <label className="filter-label">{t('transactions.filter.amount.max')}</label>
              <input 
                type="number" 
                name="maxAmount" 
                value={filters.maxAmount} 
                onChange={handleFilterChange}
                className="filter-input"
                placeholder={t('transactions.filter.amount.placeholder')}
              />
            </div> */}

            <div className="filter-group">
              <label className="filter-label">{t('transactions.filter.customer.label')}</label>
              <input 
                type="text" 
                name="customerSearch" 
                value={filters.customerSearch} 
                onChange={handleFilterChange}
                className="filter-input"
                placeholder={t('transactions.filter.customer.placeholder')}
              />
            </div>

            <div className="filter-group">
              <label className="filter-label">{t('transactions.filter.sort.label')}</label>
              <select 
                name="sortBy" 
                value={filters.sortBy} 
                onChange={handleFilterChange}
                className="filter-select"
              >
                <option value="date-desc">{t('transactions.filter.sort.options.dateDesc')}</option>
                <option value="date-asc">{t('transactions.filter.sort.options.dateAsc')}</option>
                <option value="amount-desc">{t('transactions.filter.sort.options.amountDesc')}</option>
                <option value="amount-asc">{t('transactions.filter.sort.options.amountAsc')}</option>
                <option value="points-desc">{t('transactions.filter.sort.options.pointsDesc')}</option>
                <option value="points-asc">{t('transactions.filter.sort.options.pointsAsc')}</option>
              </select>
            </div>
          </div>

          <div className="filter-actions">
            <button onClick={applyFilters} className="primary-button">{t('transactions.filter.buttons.apply')}</button>
            <button onClick={resetFilters} className="secondary-button">{t('transactions.filter.buttons.reset')}</button>
          </div>
        </div>
      </div>

      {/* Transactions Analytics */}
      <div className="analytics-section">
        <ChartCard title={t('transactions.analytics.topDays')}>
          {topDays.length > 0 && topDays.some(day => day.totalAmount > 0) ? (
            <div className="chart-placeholder">
              <div className={`chart-bars ${isRTL ? 'chart-bars-rtl' : ''}`}>
                {topDays.map((day, index) => {
                  // Calculate max amount safely
                  const maxAmount = Math.max(...topDays.map(d => d.totalAmount || 0));
                  // Calculate percentage height (avoid division by zero)
                  const heightPercentage = maxAmount > 0 
                    ? (day.totalAmount / maxAmount) * 100 
                    : 0;
                    
                  return (
                    <div className="chart-bar-container" key={index}>
                      <div 
                        className="chart-bar" 
                        style={{ 
                          height: `${heightPercentage}%`,
                          // Make bars at least 5px tall so they're visible even with tiny values
                          minHeight: heightPercentage > 0 ? '5px' : '0'
                        }}
                      ></div>
                      <div className="chart-label">{t(`transactions.days.${day.day.toLowerCase()}`)}</div>
                      <div className="chart-value">
                        {isRTL
                          ? `${day.totalAmount.toFixed(2)} ₪`
                          : `₪${day.totalAmount.toFixed(2)}`}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="empty-chart-state">
              <p>{t('transactions.analytics.noData')}</p>
              <p>{t('transactions.analytics.addTransactions')}</p>
            </div>
          )}
        </ChartCard>
      </div>

      {/* Category Stats Card */}
      {uniqueCategories.length > 0 && (
        <div className="category-stats-section">
          <h3 className="section-title">إحصائيات الفئات</h3>
          <div className="category-stats-container">
            {uniqueCategories.map(category => {
              const categoryTransactions = transactions.filter(t => 
                t.category === category && !t.isDeleted && t.points > 0
              );
              const totalAmount = categoryTransactions.reduce((sum, t) => sum + (t.amount || 0), 0);
              const totalPoints = categoryTransactions.reduce((sum, t) => sum + (t.points || 0), 0);
              const count = categoryTransactions.length;
              
              // Skip categories with no transactions
              if (count === 0) return null;
              
              return (
                <div className="category-stat-card" key={category}>
                  <div className="category-name">
                    {category}
                    <span className="category-count">({count})</span>
                  </div>
                  <div className="category-data">
                    <div className="category-amount">
                      {formatCurrency(totalAmount)}
                    </div>
                    <div className="category-points">
                      {totalPoints.toLocaleString()} نقطة
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Transactions Table */}
      <div className="transactions-table-section">
        <div className="transactions-header">
          <h3 className="section-title">{t('transactions.tableHeader.title')}</h3>
          <div className="transactions-count">
            {t('transactions.tableHeader.count', { count: filteredTransactions.length })}
          </div>
        </div>
        
        {loading ? (
          <div className="loading-container">{t('common.loading')}</div>
        ) : currentTransactions.length > 0 ? (
          <div className="enhanced-table">
            <div className="enhanced-table-header">
              <div className="header-cell">{t('transactions.table.date')}</div>
              <div className="header-cell">{t('transactions.table.customer')}</div>
              <div className="header-cell">{t('transactions.table.amount')}</div>
              <div className="header-cell">{t('transactions.table.points')}</div>
              <div className="header-cell">{t('transactions.table.status')}</div>
              <div className="header-cell">{t('transactions.table.details')}</div>
            </div>
            
            <div className="enhanced-table-body">
              {currentTransactions.map(transaction => (
                <React.Fragment key={transaction.id}>
                  <div className={`enhanced-table-row ${
                    expandedTransaction === transaction.id ? 'expanded' : ''
                  } ${transaction.isDeleted ? 'deleted-transaction' : ''}`}>
                    <div className="table-cell date-cell">
                      {transaction.timestamp?.toDate ? 
                        transaction.timestamp.toDate().toLocaleString(i18n.language) : 
                        t('common.recent')}
                    </div>
                    <div className="table-cell">
                      <div className="customer-name">{transaction.customerName || t('transactions.table.unknown')}</div>
                      <div className="customer-phone">{transaction.customerId}</div>
                    </div>
                    <div className="table-cell amount-cell">
                      {transaction.isDeleted ? (
                        <span className="deleted-text"><s>{formatCurrency(transaction.amount)}</s></span>
                      ) : (
                        formatCurrency(transaction.amount)
                      )}
                    </div>
                    <div className="table-cell points-cell">
                      {transaction.isDeleted ? (
                        <span className="deleted-text"><s>{transaction.points}</s></span>
                      ) : (
                        transaction.points
                      )}
                    </div>
                    <div className="table-cell">
                      {transaction.isDeleted ? (
                        <span className="status-badge deleted">{t('transactions.status.deleted') || 'ملغية'}</span>
                      ) : transaction.isFirstPurchase ? (
                        <span className="status-badge new">{t('transactions.status.new')}</span>
                      ) : transaction.points < 0 ? (
                        <span className="status-badge redeem">{t('transactions.status.redeem')}</span>
                      ) : transaction.points >= 100 ? (
                        <span className="status-badge reward">{t('transactions.status.highValue')}</span>
                      ) : (
                        <span className="status-badge standard">{t('transactions.status.standard') || 'عادية'}</span>
                      )}
                      {/* Show notes icon if transaction has notes */}
                      {transaction.notes && (
                        <span className="notes-icon" title="هذه المعاملة تحتوي على ملاحظات">📝</span>
                      )}
                      {/* Show category label */}
                      {transaction.category && (
                        <span className="category-label">{transaction.category}</span>
                      )}
                    </div>
                    <div className="table-cell actions-cell">
                      <button 
                        onClick={() => toggleExpandTransaction(transaction.id)} 
                        className="icon-button"
                        aria-label={expandedTransaction === transaction.id ? 
                          t('transactions.actions.collapse') : 
                          t('transactions.actions.expand')}
                      >
                        {expandedTransaction === transaction.id ? '↑' : '↓'}
                      </button>
                    </div>
                  </div>
                  
                  {expandedTransaction === transaction.id && (
                    <div className="expanded-content">
                      <div className="expanded-grid">
                        <div>
                          <div className="expanded-label">{t('transactions.expanded.id')}</div>
                          <div className="expanded-value">{transaction.id}</div>
                        </div>
                        <div>
                          <div className="expanded-label">{t('transactions.expanded.customer')}</div>
                          <div className="expanded-value">{transaction.customerName || t('transactions.table.unknown')}</div>
                        </div>
                        <div>
                          <div className="expanded-label">{t('transactions.expanded.phone')}</div>
                          <div className="expanded-value">{transaction.customerId || t('transactions.table.noID')}</div>
                        </div>
                        <div>
                          <div className="expanded-label">{t('transactions.expanded.dateTime')}</div>
                          <div className="expanded-value">
                            {transaction.timestamp?.toDate ? 
                              transaction.timestamp.toDate().toLocaleString(i18n.language) : 
                              t('common.recent')}
                          </div>
                        </div>
                        <div>
                          <div className="expanded-label">{t('transactions.expanded.amount')}</div>
                          <div className="expanded-value">{formatCurrency(transaction.amount)}</div>
                        </div>
                        <div>
                          <div className="expanded-label">{t('transactions.expanded.pointsEarned')}</div>
                          <div className="expanded-value">{transaction.points}</div>
                        </div>
                        
                        {/* Display category if available */}
                        {transaction.category && (
                          <div>
                            <div className="expanded-label">فئة المشتريات</div>
                            <div className="expanded-value">{transaction.category}</div>
                          </div>
                        )}
                        
                        {transaction.employeeName && (
                          <div>
                            <div className="expanded-label">{t('transactions.expanded.employee') || 'الموظف'}</div>
                            <div className="expanded-value">{transaction.employeeName}</div>
                          </div>
                        )}
                        
                        <div>
                          <div className="expanded-label">{t('transactions.expanded.type')}</div>
                          <div className="expanded-value">
                            {transaction.isRedemption ? 
                              t('transactions.type.redemption') || 'استبدال' : 
                              transaction.isFirstPurchase ? 
                                t('transactions.type.first') : 
                                t('transactions.type.regular')}
                          </div>
                        </div>
                        
                        {/* Add deletion information if applicable */}
                        {transaction.isDeleted && (
                          <>
                            <div>
                              <div className="expanded-label">{t('transactions.expanded.deletedAt') || 'تاريخ الإلغاء'}</div>
                              <div className="expanded-value highlight-deleted">
                                {transaction.deletedAt?.toDate ? 
                                  transaction.deletedAt.toDate().toLocaleString(i18n.language) : 
                                  t('common.unknown')}
                              </div>
                            </div>
                            <div>
                              <div className="expanded-label">{t('transactions.expanded.deletedBy') || 'تم الإلغاء بواسطة'}</div>
                              <div className="expanded-value highlight-deleted">{transaction.deletedBy || t('common.unknown')}</div>
                            </div>
                          </>
                        )}
                        
                        {/* Display notes if available */}
                        {transaction.notes && (
                          <div className="notes-container">
                            <div className="expanded-label">ملاحظات</div>
                            <div className="expanded-value notes-text">{transaction.notes}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        ) : (
          <div className="empty-state">{t('transactions.empty')}</div>
        )}
        
        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination">
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="page-button"
            >
              {isRTL ? '→' : '←'}
            </button>

            {pageNumbers.map((item, idx) =>
              item === '...' ? (
                <span key={`ellipsis-${idx}`} className="page-ellipsis">...</span>
              ) : (
                <button
                  key={item}
                  onClick={() => paginate(item)}
                  className={`page-number ${currentPage === item ? 'active' : ''}`}
                >
                  {item}
                </button>
              )
            )}

            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="page-button"
            >
              {isRTL ? '←' : '→'}
            </button>
            <span className="page-info">
              {currentPage} / {totalPages}
            </span>
          </div>
        )}
      </div>
      
      {/* Add styles for the notes display and category elements */}
      <style jsx>{`
        .notes-icon {
          display: inline-block;
          margin-right: 5px;
          font-size: 14px;
          color: #555;
          margin-left: 8px;
        }
        
        .notes-container {
          grid-column: span 2;
          border-top: 1px solid #eee;
          padding-top: 8px;
          margin-top: 5px;
        }
        
        .notes-text {
          white-space: pre-wrap;
          padding: 8px;
          background-color: #f9f9f9;
          border-radius: 4px;
          border-right: 3px solid #3498db;
          font-style: italic;
        }

        .category-label {
          display: inline-block;
          font-size: 12px;
          background-color: #f0f0f0;
          color: #666;
          padding: 2px 6px;
          border-radius: 10px;
          margin-right: 4px;
          margin-left: 4px;
        }
        
        .category-stats-section {
          margin-top: 20px;
          margin-bottom: 20px;
        }
        
        .category-stats-container {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 15px;
          margin-top: 10px;
        }
        
        .category-stat-card {
          background-color: #fff;
          border-radius: 8px;
          padding: 12px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
          transition: transform 0.2s;
        }
        
        .category-stat-card:hover {
          transform: translateY(-3px);
        }
        
        .category-name {
          font-weight: 600;
          color: #333;
          border-bottom: 1px solid #eee;
          padding-bottom: 6px;
          margin-bottom: 6px;
          display: flex;
          justify-content: space-between;
        }
        
        .category-count {
          font-weight: normal;
          color: #777;
        }
        
        .category-data {
          display: flex;
          justify-content: space-between;
          padding-top: 4px;
        }
        
        .category-amount {
          font-weight: 600;
          color: #2ecc71;
        }
        
        .category-points {
          color: #3498db;
          font-size: 0.9em;
        }
      `}</style>
    </div>
  );
};

export default TransactionsPage;